import {
    ComponentFactory
} from '@angular/core';
import { GridLength } from '../../objects/request/grid-length';

export class ColumnGrouping {
    constructor(public Name: string, public HeaderTextAlign?: string) { }
    public Width: GridLength = new GridLength(0);
}


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/objects/request/column-grouping.ts